export default __webpack_public_path__ + "static/media/IMG_9774.77ed8441.JPG";